<template>
  <v-card class="settings-card">
    <v-card-title><v-icon left>mdi-format-list-checks</v-icon>مشخصات فنی</v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-select @input="selectSpecification"
                    v-model="modelSelectedSpecification"
                    label="مشخصات مورد نظر خود را انتخاب کنید"
                    item-text="fa_name"
                    return-object
                    :items="allSpecifications"
                    color="#00ADB5" outlined dense clearable multiple>
          </v-select>
        </v-col>
      </v-row>

      <div class="spec-item sunken-block" v-for="(specification, index) in selectedSpecifications" :key="specification.id">
        <v-row dense>
          <v-col cols="12" sm="3" md="2">
            <v-text-field v-model="values[index]['order']"
                          type="number"
                          color="#00ADB5" outlined dense hide-details
                          label="ترتیب" @input="emitDataToParent">
            </v-text-field>
          </v-col>

          <template v-if="specification.type === 'STRING'">
            <v-col cols="12" sm="9" md="10">
              <h4 class="spec-item__title">{{ specification.fa_name }} <span>(متن)</span></h4>
            </v-col>
            <v-col cols="12" :md="$store.state.showEnglishFields ? 6 : 12">
              <v-text-field v-model="values[index]['fa_value']"
                            color="#00ADB5" outlined dense hide-details
                            label="فا" @input="emitDataToParent">
              </v-text-field>
            </v-col>
            <v-col v-if="$store.state.showEnglishFields" cols="12" md="6">
              <v-text-field v-model="values[index]['en_value']"
                            color="#00ADB5" outlined dense hide-details dir="ltr"
                            label="EN" @input="emitDataToParent">
              </v-text-field>
            </v-col>
          </template>

          <v-col cols="12" sm="9" md="10" v-if="specification.type === 'NUMBER'">
            <v-text-field v-model="values[index]['en_value']"
                          type="number"
                          color="#00ADB5" outlined dense hide-details
                          :label="specification.fa_name + ' (عدد)'" @input="emitDataToParent">
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="9" md="10" v-if="specification.type === 'BOOLEAN'">
            <v-select v-model="values[index]['en_value']"
                      :label="specification.fa_name"
                      item-text="title"
                      item-value="value"
                      :items="[{title: 'Yes', value: '1'}, {title: 'No', value: '0'}]"
                      color="#00ADB5" outlined dense hide-details clearable @input="emitDataToParent">
            </v-select>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SpecificationSelector",

  props: ['currentValues'],

  data() {
    return {
      modelSelectedSpecification: [],
      values: [],
      selectedSpecifications: [],
      allSpecifications: []
    }
  },

  mounted() {
    this.getSpecifications()
  },

  methods: {
    getSpecifications() {
      this.$store.dispatch("getSpecifications").then((res) => {
        this.allSpecifications = res.data

        // The create page passes no current values.
        const currentValues = this.currentValues || []
        currentValues.forEach((currentValue) => {
          this.allSpecifications.forEach((specification) => {
            if (specification.id === currentValue.specification.id) {
              this.modelSelectedSpecification.push(specification)
            }
          })
          console.log(currentValue)

          this.values.push({
            'order': currentValue.order,
            'specification_id': currentValue.specification.id,
            'en_value': currentValue.en_value,
            'fa_value': currentValue.fa_value
          });
        })
        this.selectedSpecifications = this.modelSelectedSpecification

        this.emitDataToParent()
      })
    },

    selectSpecification(data) {
      let oldValues = this.values
      this.values = []
      data.forEach((item) => {

        let finalItemData = {
          'specification_id': item.id,
          'en_value': null,
          'fa_value': null
        };

        oldValues.forEach((oldValue) => {
          if (oldValue.specification_id === item.id) {
            finalItemData = {
              'specification_id': oldValue.specification_id,
              'en_value': oldValue.en_value,
              'fa_value': oldValue.fa_value
            }
          }
        })

        this.values.push(finalItemData);
      })
      this.selectedSpecifications = data;

      this.emitDataToParent()
    },

    emitDataToParent() {
      this.$emit('specificationsUpdated', this.values)
    },
  }
}
</script>

<style scoped>
.spec-item {
  padding: 12px;
  margin-top: 12px;
}

.spec-item__title {
  font-size: 15px;
  line-height: 40px;
}

.spec-item__title span {
  color: #aab2bd;
  font-size: 13px;
}
</style>